export interface Announcements {
  id?: number;
  titulo: string;
  mensagem: string;
  grupo_clientes: any[];
  grupo_usuarios: any[];
  exigir_ciencia: boolean;
  alta_prioridade: boolean;
  status: number;
  status_cliente: number;
  data_criacao?: string;
  data_publicacao?: string;
  arquivos?: Array<any>;
  qtde_arquivos?: number;
  motivo_cancelamento?: string;
  usuario_publicacao?: string;
}

export interface AnnouncementsView extends Announcements {
  formattedStatus: string;
  formattedDate: string;
  formattedDateTime: string;
  formattedPriority: string;
  formattedRead: string;
  formattedGroup: string;
  formattedUsers: string;
  formattedFiles: AnnouncementsFile[];
  statusColor: string;
  formattedMensage: string;
  formattedMessageTooltip: string;
  isLoading: boolean;
}

export interface AnnouncementsFile {
  id: number | string;
  file: File;
  nome_arquivo: string;
  tamanho_arquivo: number | string;
}
// eslint-disable-next-line no-shadow
export enum AnnouncementsStatus {
  RASCUNHO = 0,
  PUBLICADO = 1,
  CANCELADO = 2,
}
// eslint-disable-next-line no-shadow
export enum AnnouncementsStatusCliente {
  NAO_LIDO = 0,
  LIDO = 1,
  CANCELADO = 2,
}
